// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { isBrowser } from 'react-device-detect';
import cx from 'classnames';
import Button from 'components/common/Button';
import 'moment/locale/ko';
import './QuoteCard.scss';

type Props = {
  id: string,
  thumbnail: string,
  title: string,
  urlSlug: string,
  oneColumn?: boolean,
  shortDescription: string,
  rule?: string,
  quoteStatus?: boolean,
};

const QuoteCard = ({ title, urlSlug, oneColumn, shortDescription, rule, quoteStatus }: Props) => {
  const adminLink = `/@cacheby/quotes/${urlSlug}`;
  const link = '/estimate-box';
  const tipRule = rule === 'admin' || rule === 'seller';
  return (
    <div className={cx('QuoteCard', { 'one-column': oneColumn })}>
      <Link
        className={cx('card-content', { 'tip-rule': !tipRule })}
        to={tipRule ? (rule === 'admin' ? adminLink : link) : '/quotes'}
        {...(tipRule ? {} : { 'data-tip': '파트너만 이용가능 합니다.' })}
      >
        <div className="content-head">
          <h3 className="customer-name">
            <div>{title}</div>
          </h3>
          <div className="description" style={{ WebkitBoxOrient: 'vertical' }}>
            {shortDescription}
          </div>
          <div className="buttons">
            {quoteStatus ? (
              <Button desktop={isBrowser}>종료</Button>
            ) : (
              <Button theme="outline" desktop={isBrowser}>
                진행중
              </Button>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

QuoteCard.defaultProps = {
  oneColumn: false,
  hideUsername: false,
};

export default QuoteCard;



// WEBPACK FOOTER //
// ./src/components/common/QuoteCard/QuoteCard.js